/** the query string param to specify a `lookup_key` for a Price in a checkout */
export const QS_CHECKOUT_LOOKUP_KEY = 'price';

/**
 * the query string param to specify what kind of checkout
 * Was previous used in things like `isStripeCheckout` and also in
 * `forceAbTestV2Group`
 * @deprecated maybe we get rid of this?
 */
export const QS_CHECKOUT_METHOD = 'checkout_method';

/** array of all querystring keys to preserve during checkout */
export const CHECKOUT_SHARED_QS_KEYS = [
  QS_CHECKOUT_LOOKUP_KEY,
  QS_CHECKOUT_METHOD,
];

/**
 * Filter the `search` query string to just
 * the ones that we should persist between
 * checkout stages.
 */
export const getCheckoutQueryString = (search: string) => {
  const params = new URLSearchParams(search);
  params.forEach((_, key) => {
    if (!CHECKOUT_SHARED_QS_KEYS.includes(key)) {
      params.delete(key);
    }
  });
  const qs = params.toString();
  return qs && `?${qs}`;
};
